'use strict';

import covid from './covid';
import storage from './storage';
import moment from 'moment';
import iwanthue from 'iwanthue';
import axios from 'axios';
import loader from './loader';

const smallChartColorsPalette = [
    '#e80a9a',
    '#ad0271',
    '#c00fe1',
    '#855dff',
    '#3f51b5',
    '#008eff',
    '#2fbeff',
    '#00adc3',
    '#306e8c',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#8e9c00',
    '#f7f362',
    '#ffc107',
    '#ff9800',
    '#e96237',
    '#f91302',
    '#19838e',
    '#9e9e9e',
    '#555555'
];

const config = {
    baseUrl: null,
    defaultPageId: 'yhteenveto',
    hospitalPageId: 'sairaala',
    regionPageId: 'sairaanhoitopiirit',
    municipalityPageId: 'kunnat',
    agePageId: 'ikaryhmat',
    vaccinePageId: 'rokotukset',
    sewagePageId: 'jatevesi',
    dateInputOptions: ['DD.MM.YYYY', 'D.M.YYYY', 'DD-MM-YYYY', 'D-M-YYYY', 'DD.MM', 'D.M', 'YYYY-MM-DD', 'YYYY-M-D'],
    firstDate: null, // User selected first date
    dataFirstDate: null,
    firstDayValues: {}, // Chart data first dates
    rateDays: null,
    wave: null,
    delayInResults: moment().set({ hour: 12, minute: 0 }).add(-5, 'day').toDate(),
    chartColors: smallChartColorsPalette,
    largeColorPalette: iwanthue(320, {
        colorSpace: {
            cmin: 24,
            cmax: 100,
            lmin: 15,
            lmax: 85
        },
        seed: 'korona-palette-5',
        quality: 100
    }),
    ga: 'UA-163115936-1',
    dataTimestamp: null
};

function initConfig() {
    const coronaElem = document.getElementById('corona');
    config.baseUrl = coronaElem.getAttribute('data-baseurl') || null;
    config.dataTimestamp = coronaElem.getAttribute('data-reload-timestamp') || null;

    // Set rate days
    config.rateDays = 14;
    /*
    const rateDaysInput = document.getElementById('rateDays');

    let savedRateDays = storage.getData('chartRateDays');
    if (savedRateDays) {
        savedRateDays = parseInt(savedRateDays);
        savedRateDays = !isNaN(savedRateDays) ? savedRateDays : null;

        if (savedRateDays && [14, 21, 28].includes(savedRateDays)) {
            rateDaysInput.value = savedRateDays;
        }
    }

    config.rateDays = savedRateDays ? savedRateDays : parseInt(rateDaysInput.value);


    // Listen for changes
    rateDaysInput.addEventListener('change', function (e) {
        const newRate = parseInt(this.value);
        window.config.rateDays = !isNaN(newRate) ? newRate : config.rateDays;
        storage.updateData('chartRateDays', config.rateDays);
        covid.reinitIncidenceRates();
    });*/

    // Initial wave selection
    let savedWave = storage.getData('chartWave');
    if (savedWave) {
        savedWave = [1,3,4].includes(savedWave) ? savedWave : null;
    }
    config.wave = savedWave || parseInt(document.querySelector('input[name="wave"]:checked').value);

    // Get all radio buttons and attach listeners
    const waveInputs = document.getElementsByClassName('wave-input');
    for (let input of waveInputs) {
        if (parseInt(input.value) === config.wave) {
            input.checked = true;
        }

        input.onclick = function(e) {
            window.config.wave = !isNaN(parseInt(this.value)) ? parseInt(this.value) : window.config.wave;
            storage.updateData('chartWave', window.config.wave);

            // Update rest of the inputs
            for (let input of waveInputs) {
                let currentValue = parseInt(input.value);
                if (currentValue === window.config.wave && !input.checked) {
                    input.checked = true;
                } else if (currentValue !== window.config.wave && input.checked) {
                    input.checked = false;
                }
            }

            covid.reinitWave();
        };
    }

    // Set first date for charts

    // Get from local storage
    const savedChartFirstDate = storage.getData('chartFirstDate');
    const savedChartFirstDateMoment = savedChartFirstDate ? moment(savedChartFirstDate, config.dateInputOptions) : null;
    if (savedChartFirstDateMoment && savedChartFirstDateMoment.isValid()) {
        config.firstDate = savedChartFirstDateMoment;
    } else {
        // Set chart first date based on window width
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 10;
        config.firstDate = width > 1024 ? moment().add(-18, 'months') : moment().add(-16, 'months');
    }

    // First date for data to be fetched
    // config.dataFirstDate = moment(config.firstDate.format()).subtract(14, 'days')
    config.dataFirstDate = moment('2020-01-01');

    // Add event listener for date change
    const timePeriodSelect = document.getElementById('covid-data-period');
    timePeriodSelect.value = config.firstDate.format('YYYY-MM-DD');
    timePeriodSelect.addEventListener('change', function() {
        const firstDate = moment(this.value, window.config.dateInputOptions);
        if (firstDate.isValid()) {
            window.config.firstDate = firstDate;
            storage.updateData('chartFirstDate', this.value);

            // Check if new data needs to be loaded
            /*const reguiredDataFirstDate = moment(window.config.firstDate.format()).subtract(14, 'days');
            if (window.config.dataFirstDate > reguiredDataFirstDate) {
                window.config.dataFirstDate = reguiredDataFirstDate;

                const page = document.getElementById('corona');
                loader.start(page);

                axios({
                    method: 'get',
                    url: '/stage-ajax/getCorona/',
                    responseType: 'json',
                    params: {
                        initial: false,
                        firstDate: window.config.dataFirstDate.format('YYYY-MM-DD')
                    }
                }).then(function (response) {
                    covid.reloadData(response.data);
                    loader.end(page);
                });

            } else {
                // We have enough data, reinit charts
                covid.reinitDates();
            }*/

            covid.reinitDates();
        }
    });

    return config;
}

export default initConfig

